/* Inner pages: same header behaviour as the homepage.
   Fixed overlay, transparent at top, glass after 80px,
   hides on scroll down and returns on scroll up. */
(function () {
  if (document.body.classList.contains('template-index')) return;
  var header = document.querySelector('.header-wrapper');
  var main = document.getElementById('MainContent');
  if (!header || !main) return;
  var lastY = window.scrollY;
  var threshold = 80;

  var strip = document.querySelector('.announcement-bar-section');
  function place() {
    // sit directly under the announcement strip, and stick to the very top once it scrolls away
    var bottom = strip ? strip.getBoundingClientRect().bottom : 0;
    header.style.top = Math.max(0, bottom) + 'px';
  }
  // Body colour/gradient already runs behind the fixed header, so simply
  // push the page content below it.
  function offset() {
    main.style.paddingTop = '';
    place();
  }
  function onScroll() {
    var y = window.scrollY;
    if (y > threshold) {
      header.classList.add('header-wrapper--glass');
      header.classList.toggle('header-wrapper--scrolled-down', y > lastY);
    } else {
      header.classList.remove('header-wrapper--glass', 'header-wrapper--scrolled-down');
    }
    lastY = y;
    place();
  }
  offset();
  window.addEventListener('resize', offset);
  window.addEventListener('load', offset);
  window.addEventListener('scroll', onScroll, { passive: true });
})();
